import { setRegistry } from "@sinch/mfe-loader";

// This is done so we can be backwards compatible with cached versions of the HTML file
// that still uses an older version of the mfe-loader
export const setMFELoaderRegistrySafe = (
  registry: CustomElementRegistry
): string => {
  try {
    setRegistry(registry);
  } catch (_) {
    // Do nothing
  }
  const MFELoaderHost = window.customElements.get(
    "mfe-loader"
    // eslint-disable-next-line
  ) as any;
  return MFELoaderHost?.version ?? "0.0.0";
};
